import { useSequences } from "sdk/command-palette/queries"

export const PAGE_ID = "sequence-search"

export const SHORTCUT = "f e"

const SEARCH_ENTRY_COMMAND = {
  id: "search-sequences",
  label: "Search Email Sequences…",
  icon: "search",
  group: "Search",
  keywords: ["find", "sequence", "course", "email"],
  shortcut: SHORTCUT,
  onSelect: api => api.pushPage(PAGE_ID)
}

/**
 * Provider for sequence search. At the root it offers the "Search sequences…"
 * entry that opens the subpage. Like tags and segments, the whole sequence list
 * is small and changes rarely, so we preload it once when the subpage opens and
 * let cmdk filter it client-side (the subpage sets `shouldFilter: true`).
 * Selecting a sequence navigates to it.
 *
 * @type {import("../types").Provider}
 */
export function useSequenceSearchProvider({ activePageId }) {
  const active = activePageId === PAGE_ID

  const { data, isFetching } = useSequences({ enabled: active })

  if (!activePageId) {
    return { commands: [SEARCH_ENTRY_COMMAND], isLoading: false }
  }

  if (!active) return { commands: [], isLoading: false }

  const commands = (data?.sequences ?? []).map(sequence => ({
    id: `sequence-${sequence.id}`,
    label: sequence.name,
    icon: "mailbox",
    group: "Email Sequences",
    href: `/sequences/${sequence.id}`,
    onSelect: api => api.navigate(`/sequences/${sequence.id}`)
  }))

  return { commands, isLoading: isFetching }
}

/**
 * @returns {import("../types").Shortcut[]}
 */
export function getSequenceSearchShortcuts() {
  return [{ shortcut: SHORTCUT, onTrigger: api => api.pushPage(PAGE_ID) }]
}
